import ReactDOM from 'react-dom/client';
import './index.scss';
import './';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
